import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { GetNotesService } from 'app/note/get-notes.service';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import { NoteDetailsFragment, NoteTarget } from 'generated/graphql';
import { takeUntil } from 'rxjs';
@Component({
  selector: 'app-create-and-view-notes',
  templateUrl: './create-and-view-notes.component.html',
  styleUrls: ['./create-and-view-notes.component.scss']
})

export class CreateAndViewNotesComponent extends WithDisposableSubject()
  implements OnInit {
  @Input() targetType: NoteTarget;
  @Input() targetId: string;
  @Input() campaignId: string;
  @Input() shouldAutofocusInput = false;

  showNotes = false;

  notes: Array<NoteDetailsFragment> = [];

  constructor(
    private _getNotesService: GetNotesService,
    private _cd: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this._getNotesService.getNotes(
      this.targetType,
      this.targetId,
      this.campaignId
    )?.pipe(
      takeUntil(this.disposer)
    ).subscribe((notes) => {
      this.notes = notes;
      this._cd.detectChanges();
    });
  }

  noteAdded(event: any) {
  }
}
